import useWishlist from "../../../src/hooks/useWishlist";
import SearchSheet from "../../../src/components/searchSheet";
import Wishlist from "../../../src/components/Wishlist";
import { User } from "lucide-react";
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { CartDrawer } from "../../../src/components/cartDrawer";

// Debounce function

export default function MobileBar({
  isMobile,
}: {
  isMobile: boolean;
}) {
  const { data: wishlist } = useWishlist();
  const [showMenu, setShowMenu] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isAtBottom, setIsAtBottom] = useState(false);
  const nav = useNavigate();

  // Handle scroll event
  useEffect(() => {
    const handleShowMenu = () => {
      const currentScrollY = window.scrollY;
      const scrollHeight =
        document.documentElement.scrollHeight;
      const windowHeight = window.innerHeight;

      // Check if at the bottom of the page
      if (currentScrollY + windowHeight >= scrollHeight) {
        setIsAtBottom(true);
      } else {
        setIsAtBottom(false);
      }

      // Only update state if scroll direction is different
      if (currentScrollY > lastScrollY && !isAtBottom) {
        setShowMenu(true); // Scrolling down
      } else if (currentScrollY < lastScrollY) {
        setShowMenu(false); // Scrolling up or at the top
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleShowMenu);

    return () => {
      window.removeEventListener("scroll", handleShowMenu);
    };
  }, [lastScrollY, isAtBottom]);

  return (
    <div
      className={`duration-500 fixed bottom-0 z-50 dark:bg-neutral-900 bg-white border-t w-screen pt-3 pb-3 flex justify-between ${
        showMenu ? "translate-y-20" : ""
      } ${isAtBottom ? "hidden" : ""}`}
    >
      <div className="w-full flex flex-col gap-2 justify-center items-center">
        <CartDrawer scrolled={isMobile} />
        <span className="text-[10px]">CART</span>
      </div>
      <div className="w-full flex flex-col gap-2 justify-center items-center">
        <SearchSheet scrolled={isMobile} />
        <span className="text-[10px]">SEARCH</span>
      </div>
      <button
        className="w-full flex flex-col gap-2 justify-center items-center"
        onClick={() => {
          nav("/shop");
          window.scrollTo(0, 0);
        }}
      >
        <img
          src="/logo-aaa.png"
          alt="amadeus"
          className="w-6 dark:invert"
        />
        <span className="text-[10px]">SHOP</span>
      </button>
      <div className="w-full flex flex-col gap-2 justify-center items-center">
        <Wishlist
          navBar
          wishlist={wishlist}
          scrolled={isMobile}
        />
        <span className="text-[10px]">WISHLIST</span>
      </div>
      <div className="w-full flex flex-col gap-2 justify-center items-center">
        <Link to="/profile">
          <User className="stroke-1 text-neutral-100 h-6 w-6 text-neutral-900 dark:text-neutral-100" />
        </Link>
        <span className="text-[10px]">ACCOUNT</span>
      </div>
    </div>
  );
}
